<script>
import FilterGenerator from '@/components/general/FilterGenerator'
import LearningCardList from '@/components/general/LearningCardList'
import EmptyList from '@/components/general/EmptyList'
export default {
  name: 'WorkspaceListsTabTemplate',
  components: {
    EmptyList,
    LearningCardList,
    FilterGenerator
  },
  props: {
    lists: {
      type: Array
    },
    noFilter: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      currentMountedFilters: null,
      filterOptions: {
        actionButton: {
          vif: false,
          color: '#1200D3',
          icon: 'mdi-plus',
          text: this.$t('content.modal:add.list'),
          outline: true
        },
        filterFields: [
          { key: 'name_search', type: 'input_field', text: this.$t('global:search') },
          {
            key: 'content_type',
            type: 'select_field',
            text: this.$t('content:type'),
            options: this.$store.getters.getContentTypes.map(contentType => ({
              id: contentType.id,
              text: this.$t(`content.type:${contentType.alias}`)
            }))
          },
          {
            key: 'skill',
            type: 'select_field',
            text: this.$t('global:skills'),
            multiple: true,
            firstOnly: true,
            options: this.$store.getters.getAvailableSkills.map(skill => ({
              id: skill.id,
              text: skill.title
            })),
            value: []
          }
        ]
      },
      emptyList: {
        title: '',
        textOne: '',
        buttonText: ''
      }
    }
  },
  watch: {
    'currentMountedFilters' () {
      this.debounceListFilters()
    },
    '$route.name' () {
      this.debounceListFilters()
    },
    'selectedWorkspace' () {
      this.filterOptions.actionButton.vif = this.profileBelongsLoggedUser
    }
  },
  computed: {
    isFilterEmpty () {
      return !this.currentMountedFilters || this.objIsEmpty(this.currentMountedFilters)
    }
  },
  methods: {
    mountFilter (filter) {
      const mountedFilter = {}
      if (filter.name_search) {
        mountedFilter.textualDescription = filter.name_search
      }
      if (filter.content_type) {
        mountedFilter.type = filter.content_type
      }
      if (filter.skill && filter.skill.length) {
        mountedFilter.skills = filter.skill
      }
      return mountedFilter
    },
    changedFilter (resultFilter) {
      this.currentMountedFilters = this.mountFilter(resultFilter)
    },
    pushToAddList () {
      const params = { workspaceId: this.$route.params.id }
      this.$router.push({ name: `${this.$route.name}.lists.manage`, params })
    },
    debounceListFilters () {
      this.debounceEvent(() => {
        this.$emit('updateList', this.currentMountedFilters)
      }, 450)
    },
    validateWorkspace () {
      if (this.selectedWorkspace.type === 'individual') {
        this.$router.push({ name: this.selectedWorkspace.type + '.discovery.index.search', query: { type: 'contents' } })
      } else if (this.selectedWorkspace.type === 'business') {
        this.$router.push({ name: this.selectedWorkspace.type + '.discovery.index', query: { companyDomain: this.selectedWorkspace.name } })
      }
    },
    defineEmptyList () {
      if (this.selectedWorkspace.role !== 'member') {
        this.emptyList.title = this.$t('empty.state.title:empty.title')
        this.emptyList.textOne = this.$t('empty.state.text:my.lists.text')
        this.emptyList.buttonText = this.$t('empty.state.button:add.list')
      } else {
        this.emptyList.title = this.$t('empty.state.title:empty.title')
        this.emptyList.textOne = this.$t('empty.state.text.list:empty.text')
        this.emptyList.buttonText = null
      }
    }
  },
  created () {
    this.defineEmptyList()
    this.filterOptions.actionButton.vif = this.userCanCreateContent
  }
}
</script>
<template>
  <div class="workspace-list--tab" :key="selectedWorkspace.id">
    <filter-generator
      v-if="!noFilter"
      :options="filterOptions"
      @change="changedFilter"
      multiple
      firstOnly
      @actionBtnSubmit="pushToAddList"
    />
    <empty-list class="empty-list" v-if="(!lists || !lists.length)"  @btnClick="pushToAddList()"
        :title="emptyList.title"
        :textOne="emptyList.textOne" :image="'/assets/images/empty-box.png'"
        :buttonText="emptyList.buttonText"
        :validateRole="this.selectedWorkspace.role !== 'member'"></empty-list>
    <div class="workspace-list--contents">
      <template v-if="lists && lists.length">
        <div class="workspace-content--item" v-for="(list, index) in lists" :key="index">
          <learning-card-list
            :list="list"
            allowUpdate
            originWindow=".workspace"
            showItemsProgress
          ></learning-card-list>
        </div>
      </template>
    </div>
    <router-view/>
  </div>
</template>
<style lang="scss">
.workspace-list--tab {
  margin-top: 20px;
  .workspace-list--contents {
    display: grid;
    grid-gap: 16px;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    margin-top: 20px;
    .workspace-content--item {
      display: inline-block;
      padding: 0;
      .learning-card--container {
        margin: 0;
        width: 100%;
      }
    }

    .empty-block {
      .empty-img {
        margin: 45px auto 30px;
      }

      .empty-text {
        font-family: $lato;
        font-size: $font-size-normal;
        margin-top: -20px;
        color: $neutral-medium;
      }
    }
  }
  @media only screen and (max-width: 1230px) {
    width: calc(100% - 40px);
    margin: 20px auto;
  }
  @media only screen and (max-width: 768px) {
    .workspace-list--contents {
      justify-content: center;
      margin-top: 0;
    }
  }
  @media only screen and (max-width: 600px) {
    .workspace-list--contents {
      justify-content: center;
    }
  }
}
</style>
